export default __webpack_public_path__ + "static/media/video.091d5748.jpg";